export default __webpack_public_path__ + "static/media/homeLineupLeftPolygon.df25b1fb.svg";